import { render, staticRenderFns } from "./_base-subCard.vue?vue&type=template&id=142d906d&scoped=true&"
import script from "./_base-subCard.vue?vue&type=script&lang=js&"
export * from "./_base-subCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142d906d",
  null
  
)

export default component.exports